import script from "./HrMenuGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./HrMenuGroup.vue?vue&type=script&setup=true&lang=js"

import "./HrMenuGroup.vue?vue&type=style&index=0&id=3af8be6c&lang=scss"

const __exports__ = script;

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QExpansionItem});
